"use client";
import { useEffect, useState } from "react";
import screenSizes from "../lokalni/constant";
import SubscriptionMobile from "../components/cenik/SubscriptionMobile";
import SubscriptionTablet from "../components/cenik/SubscriptionTablet";
import SubscriptionDesktop from "../components/cenik/SubscriptionDesktop";

const CenikPage = () => {
  const [width, setWidth] = useState<number | undefined>(undefined);
  const [screen, setScreen] = useState<string | null>(null);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setWidth(window.innerWidth);

      const handleResize = () => {
        setWidth(window.innerWidth);
      };

      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);

  useEffect(() => {
    if (width === undefined) {
      return;
    }

    if (width < 744) {
      setScreen(screenSizes.MOBILE);
    } else if (width >= 744 && width <= 1279) {
      setScreen(screenSizes.TABLET);
    } else {
      setScreen(screenSizes.DESKTOP);
    }
  }, [width]);

  if (screen === screenSizes.MOBILE) {
    return <SubscriptionMobile />;
  } else if (screen === screenSizes.TABLET) {
    return <SubscriptionTablet />;
  } else {
    return <SubscriptionDesktop />;
  }
};

export default CenikPage;
